/**
 * 경원 규격 표시 — 규격 칩 "표층용(WC-2)1등급"(등급 없으면 "표층용(WC-2)") + 골재치수 칩 "13mm" 따로. 10-22 사용자 지정.
 * 칩 모양은 놓이는 곳의 것을 받는다(시트·모달 .dispatch-mix-chip · MO 카드 .dsc-mix-chip).
 * 규격 칩만 입도 계열 색 .ascon-grade-chip.is-wc / .is-bb (WC 파랑 · BB 주황, 그 밖은 기본 칩). 골재치수는 기본 칩.
 */
import { asconSpec, type AsconOrder } from "@/domain/asconShipment";

type SpecSrc = Pick<AsconOrder, "kind" | "maxAgg">;
const NONE = <span className="dispatch-row-mix">—</span>;

/** 규격 칩 (시트 "규격" 칸) */
export function AsconSpecChip({ order, chipClass = "dispatch-mix-chip" }: { order: SpecSrc; chipClass?: string }) {
  const spec = asconSpec(order);
  if (!spec.name) return NONE;
  const fam = spec.gradeFamily ? ` ascon-grade-chip is-${spec.gradeFamily}` : "";
  return <span className={`${chipClass}${fam}`} title={spec.name}>{spec.name}</span>;
}

/** 골재치수 칩 (시트 "골재" 칸) */
export function AsconAggChip({ order, chipClass = "dispatch-mix-chip" }: { order: SpecSrc; chipClass?: string }) {
  const { agg } = asconSpec(order);
  return agg ? <span className={chipClass}>{agg}</span> : NONE;
}

/** 규격 + 골재치수 한 줄 (MO 카드·모달) */
export function AsconSpecPair({ order, chipClass = "dispatch-mix-chip" }: { order: SpecSrc; chipClass?: string }) {
  const spec = asconSpec(order);
  if (!spec.name && !spec.agg) return NONE;
  return (
    <span className="ascon-spec-pair">
      {spec.name && <AsconSpecChip order={order} chipClass={chipClass} />}
      {spec.agg && <span className={chipClass}>{spec.agg}</span>}
    </span>
  );
}
